export const isProductBonusGift = (productNumber, domain) => {
  if (domain === "NZ") {
    return !!nzBonusGiftData[productNumber];
  } else if (domain === "AU") {
    return !!auBonusGiftData[productNumber];
  } else {
    return false;
  }
};

const nzBonusGiftData = {};

const auBonusGiftData = {
  "1366115": true,
  "1366116": true,
  "1306815": true,
  "1306813": true,
  "1303674": true,
  "1303675": true,
  "1303672": true,
  "1303673": true,
  "1303566": true,
  "1303567": true,
  "1303930": true,
  "1300795": true,
  "1303929": true,
  "1303928": true,
  "1303677": true,
  "1303678": true,
  "1300794": true,
  "1303676": true,
  "1303565": true,
  "1303927": true,
  "1306814": true,
  "1303573": true,
  "1303571": true,
  "1303570": true,
  "1303568": true,
  "1306816": true,
  "1306817": true,
  "1306819": true,
  "1306820": true,
  "1306818": true,
  "1306822": true,
  "1306821": true,
  "1306823": true,
  "1306824": true,
  "1366288": true,
  "1366287": true,
  "1361416": true,
  "1361415": true,
  "1361418": true,
  "1361417": true,
  "1361422": true,
  "1361421": true,
  "1361420": true,
  "1361419": true,
  "1361411": true,
  "1361412": true,
  "1361414": true,
  "1361413": true,
  "1313418": true,
  "1313419": true,
  "1313417": true,
  "1313416": true,
  "1361684": true,
  "1361685": true,
  "1361686": true,
  "1361687": true,
  "1361688": true,
  "1361689": true,
  "1313406": true,
  "1313407": true,
  "1361427": true,
  "1361428": true,
  "1300617": true,
  "1366190": true,
  "1366191": true,
  "1361277": true,
  "1361278": true,
  "1361279": true,
  "1300042": true,
  "1300044": true,
  "1300329": true,
  "1306949": true,
  "1300053": true,
  "1300055": true,
  "1300058": true,
  "1300363": true,
  "1306950": true,
  "1300064": true,
  "1300065": true,
  "1300536": true,
  "1300535": true,
  "1300718": true,
  "1300066": true,
  "1300067": true,
  "1300367": true,
  "1300068": true,
  "1300069": true,
  "1300070": true,
  "1300071": true,
  "1300073": true,
  "1300074": true,
  "1309866": true,
  "1309867": true,
  "1309869": true,
  "1309870": true,
  "1309871": true,
  "1309872": true,
  "1309873": true,
  "1309877": true,
  "1309874": true,
  "1309878": true,
  "1309875": true,
  "1360878": true,
  "1360879": true,
  "1360880": true,
  "1360881": true,
  "1360882": true,
  "1305895": true,
  "1312601": true,
  "1312603": true,
  "1300750": true,
  "1305894": true,
  "1300745": true,
  "1312528": true,
  "1312530": true,
  "1300091": true,
  "1300094": true,
  "1300093": true,
  "1300096": true,
  "1300095": true,
  "1301117": true,
  "1301116": true,
  "1301121": true,
  "1366000": true,
  "1366079": true,
  "1366001": true,
  "1366002": true,
  "1366081": true,
  "1366003": true,
  "1366084": true,
  "1366083": true,
  "1307156": true,
  "1307155": true,
  "1307189": true,
  "1307187": true,
  "1307188": true,
  "1307186": true,
  "1307193": true,
  "1307191": true,
  "1307192": true,
  "1307190": true,
  "1361128": true,
  "1361126": true,
  "1361124": true,
  "1361127": true,
  "1361125": true,
  "1361123": true,
  "1361134": true,
  "1361132": true,
  "1361130": true,
  "1361133": true,
  "1361131": true,
  "1361129": true,
  "1366078": true,
  "1366076": true,
  "1366077": true,
  "1366075": true,
  "1306979": true,
  "1306981": true,
  "1306978": true,
  "1306980": true,
  "1307176": true,
  "1307178": true,
  "1307175": true,
  "1307177": true,
  "1307180": true,
  "1307182": true,
  "1307179": true,
  "1307181": true,
  "1381131": true,
  "1381133": true,
  "1381132": true,
  "1381134": true,
  "1307184": true,
  "1307183": true,
  "1366071": true,
  "1366073": true,
  "1366072": true,
  "1366074": true,
  "1305176": true,
  "1305178": true,
  "1305177": true,
  "1305179": true,
  "1303785": true,
  "1303787": true,
  "1303786": true,
  "1303788": true,
  "1303782": true,
  "1303784": true,
  "1303781": true,
  "1303783": true,
  "1306983": true,
  "1306985": true,
  "1306982": true,
  "1306984": true,
  "1306987": true,
  "1306989": true,
  "1306986": true,
  "1306988": true,
  "1306991": true,
  "1306993": true,
  "1306990": true,
  "1306992": true,
  "1306995": true,
  "1306997": true,
  "1306994": true,
  "1306996": true,
  "1318459": true,
  "1367002": true,
  "136004": true,
  "1367003": true,
  "136000": true,
  "136002": true,
  "136003": true
};
